import { render, staticRenderFns } from "./KTextDisplay.vue?vue&type=template&id=ad5075ea&scoped=true&"
import script from "./KTextDisplay.vue?vue&type=script&lang=js&"
export * from "./KTextDisplay.vue?vue&type=script&lang=js&"
import style0 from "./KTextDisplay.vue?vue&type=style&index=0&id=ad5075ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5075ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
